// GetCoordinates v1.2
// returns element coordinates relative to the page or a scrollable container

// usage:
// import {getPageCoordinates, getRelativeCoordinates} from './GetCoordinates.js';
// const coords = getPageCoordinates(element);
// const coords = getRelativeCoordinates(element, container);

// returns:
// top, bottom, left, right

// notes:
// getPageCoordinates: converts viewport-relative values into page-relative coordinates
// that stay stable when the window scrolls
// do not use this for checking whether something is in view;
// for in-view checks, use getBoundingClientRect() directly because that is viewport-based
// sticky and fixed element coordinates change on scroll, so getPageCoordinates is not suitable for those
// getRelativeCoordinates: returns coordinates relative to a scrollable container element
// useful when animating scroll inside a non-body scroller (e.g. a popover)

// changelog:
// 1.0 initial version, extracted from resize helpers and renamed for clarity
// 1.1 remove width and height, because those are not page coordinates
// 1.2 add getRelativeCoordinates, rename module to GetCoordinates

export const getPageCoordinates = el => {
  const rect = el.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  const top = rect.top + scrollTop - clientTop;
  const left = rect.left + scrollLeft - clientLeft;
  const bottom = top + rect.height;
  const right = left + rect.width;

  return {
    top: Math.round(top),
    bottom: Math.round(bottom),
    left: Math.round(left),
    right: Math.round(right),
  };
};

export const getRelativeCoordinates = (el, container) => {
  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const top = elRect.top - containerRect.top + container.scrollTop;
  const left = elRect.left - containerRect.left + container.scrollLeft;
  const bottom = top + elRect.height;
  const right = left + elRect.width;

  return {
    top: Math.round(top),
    bottom: Math.round(bottom),
    left: Math.round(left),
    right: Math.round(right),
  };
};

export default getPageCoordinates;